// src/components/Dashboard/DashboardGrid.tsx
// 12-column responsive grid that renders the active widget set.
// colSpan values: 3 = quarter, 4 = third, 6 = half, 12 = full.
// Responsive collapse: all widgets stack to full-width on small screens.
import { ReactNode } from 'react'
import { WidgetConfig } from './types'

const COL_CLASS: Record<3 | 4 | 6 | 12, string> = {
  3:  'col-span-12 sm:col-span-6 lg:col-span-3',
  4:  'col-span-12 sm:col-span-6 lg:col-span-4',
  6:  'col-span-12 lg:col-span-6',
  12: 'col-span-12',
}

interface DashboardGridProps {
  /** Ordered list of widget configs to render (already filtered for tier + visibility). */
  activeWidgets: WidgetConfig[]
  /** Render function — maps widgetId → JSX. Returns null for unbuilt widgets. */
  renderWidget:  (id: string) => ReactNode
}

export function DashboardGrid({ activeWidgets, renderWidget }: DashboardGridProps) {
  if (activeWidgets.length === 0) {
    return (
      <div className="col-span-12 py-10 text-center text-sm text-gray-400">
        No widgets active — use <strong>Customise dashboard</strong> to add some.
      </div>
    )
  }

  return (
    <div className="grid grid-cols-12 gap-4">
      {activeWidgets.map(cfg => {
        const node = renderWidget(cfg.id)
        if (!node) return null
        return (
          <div key={cfg.id} className={COL_CLASS[cfg.colSpan]}>
            {node}
          </div>
        )
      })}
    </div>
  )
}
